import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  dropLast1vpiyky649o34 as dropLast,
  last1vo29oleiqj36 as last,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  sortedWith2csnbbb21k0lg as sortedWith,
  takeLasttm5u17ojwaaq as takeLast,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  LineItemState_NotStarted_getInstance3brd4lyoananz as LineItemState_NotStarted_getInstance,
  LineItemState_InProgress_getInstance30c0b4tuqukui as LineItemState_InProgress_getInstance,
  LineItemState_Cancelled_getInstance3kcyrqker8w6h as LineItemState_Cancelled_getInstance,
  EscalationLevel_NotApproved_getInstance172k2scjitveo as EscalationLevel_NotApproved_getInstance,
  EscalationLevel_Issue_getInstancea8pbpo27up2o as EscalationLevel_Issue_getInstance,
  EscalationLevel_Disputed_getInstance3pwh4crkd38ie as EscalationLevel_Disputed_getInstance,
  LineItemState_ResolveLater_getInstance12e6r673b4g9c as LineItemState_ResolveLater_getInstance,
  LineItemState_NotApproved_getInstance1n0ztla6z4oyz as LineItemState_NotApproved_getInstance,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  LineItemState_Resolved_getInstance3gyqdeh0a3lwt as LineItemState_Resolved_getInstance,
  LineItemState_KeepWorking_getInstanceieb6rws75lm1 as LineItemState_KeepWorking_getInstance,
  LineItemState_OnHold_getInstance5v65qotr6ndv as LineItemState_OnHold_getInstance,
  LineItemState_Disputed_getInstance1ejlicwa0ud20 as LineItemState_Disputed_getInstance,
  LineItemState_RequestingReview_getInstance2ojeopd3nid3v as LineItemState_RequestingReview_getInstance,
} from '../enums.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  ClientResponse3rdi8ggal48xs as ClientResponse,
  Accept733y3zepx42g as Accept,
  RequestResolveLater_instance1haqv4qpxez7b as RequestResolveLater_instance,
  get_isSignOff22izp8i5fus79 as get_isSignOff,
  NeedsApproval1ftfboe6wlgyi as NeedsApproval,
  KeepWorking_instance1l6z7q2tbtqni as KeepWorking_instance,
  Remedy1wqpxp6byw9t6 as Remedy,
  ClientResolution1kcdgkwzeikik as ClientResolution,
  MoreInfo_instance2thszg9d7ysff as MoreInfo_instance,
  ForceCompletemak8s8g9i3mp as ForceComplete,
  RequestSiteVisit1o0qmklsbtvus as RequestSiteVisit,
  Appealdu3t1bemwr4j as Appeal,
  MoreInfof0qn3z2grweu as MoreInfo,
} from './CompletionResponse.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { asReversed308kw52j6ls1u as asReversed } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ReversedViews.mjs';
import { Companion_getInstance1twm7uvvfawb7 as Companion_getInstance } from '../supportModels.mjs';
import { isComplete3isyniin1qz2u as isComplete } from '../statePermissions.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
  Duration__compareTo_impl_pchp0f3d3hhywzdbk51 as Duration__compareTo_impl_pchp0f,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_HOURS_getInstancebu9fos347hpz as DurationUnit_HOURS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function rewind($this, _this__u8e3s4, messages, timestamp, compare) {
  if (messages.i1()) {
    var tmp0_safe_receiver = _this__u8e3s4.w6k_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (compare(tmp0_safe_receiver.o54_1, timestamp)) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return _this__u8e3s4.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp);
  }
  var messagesBefore = dropLast(messages, 1);
  var last_0 = last(messages);
  var tmp_1 = rewind($this, _this__u8e3s4, messagesBefore, last_0.e6h_1, compare);
  var tmp1_safe_receiver = $this.w8v_1;
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_3;
    if (compare(tmp1_safe_receiver, timestamp)) {
      tmp_3 = tmp1_safe_receiver;
    } else {
      tmp_3 = null;
    }
    tmp_2 = tmp_3;
  }
  var history = LineItemHistory().c8w(tmp_1, messagesBefore, tmp_2);
  var tmp2_safe_receiver = _this__u8e3s4.w6k_1;
  var tmp_4;
  if (tmp2_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_5;
    if (compare(tmp2_safe_receiver.o54_1, timestamp)) {
      tmp_5 = tmp2_safe_receiver;
    } else {
      tmp_5 = null;
    }
    tmp_4 = tmp_5;
  }
  var tmp7_complete = tmp_4;
  var tmp_6;
  if (!(_this__u8e3s4.y6k_1 == null) && compare(_this__u8e3s4.y6k_1, timestamp)) {
    tmp_6 = LineItemState_Cancelled_getInstance();
  } else {
    var tmp3_safe_receiver = lastOrNull(messages);
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.d8w();
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.e8w(history);
    var tmp6_elvis_lhs = tmp5_elvis_lhs == null ? history.f8w() : tmp5_elvis_lhs;
    tmp_6 = tmp6_elvis_lhs == null ? !(_this__u8e3s4.o6k_1 == null) && compare(_this__u8e3s4.o6k_1, timestamp) ? LineItemState_InProgress_getInstance() : LineItemState_NotStarted_getInstance() : tmp6_elvis_lhs;
  }
  var tmp8_state = tmp_6;
  return _this__u8e3s4.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp8_state, VOID, VOID, VOID, VOID, VOID, VOID, tmp7_complete);
}
function rewind_0($this, timestamp, compare) {
  // Inline function 'kotlin.collections.takeWhile' call
  var this_0 = $this.v8v_1;
  var list = ArrayList().w();
  var _iterator__ex2g4s = this_0.m1();
  $l$loop: while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    if (!compare(item.e6h_1, timestamp))
      break $l$loop;
    list.v(item);
  }
  var messages = list;
  var tmp = rewind($this, $this.u8v_1, messages, timestamp, compare);
  var tmp0_safe_receiver = $this.w8v_1;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_1;
    if (compare(tmp0_safe_receiver, timestamp)) {
      tmp_1 = tmp0_safe_receiver;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  return LineItemHistory().c8w(tmp, messages, tmp_0);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.g8w_1 = function_0;
      }
      wi(a, b) {
        return this.g8w_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.g8w_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function LineItemHistory$_init_$lambda_hk1xcy(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.e6h_1;
  var tmp$ret$1 = b.e6h_1;
  return compareValues(tmp, tmp$ret$1);
}
function LineItemHistory$_get_issueRaisedAt_$ref_pwsylh() {
  return (p0) => p0.h8w();
}
function LineItemHistory$_get_disputeFiledAt_$ref_2ar8qu() {
  return (p0) => p0.i8w();
}
function LineItemHistory$_get_resolveLaterAcceptedAt_$ref_61csev() {
  return (p0) => p0.j8w();
}
function LineItemHistory$_get_signOffCount_$ref_2pqnxo() {
  return (p0) => p0.k8w();
}
function LineItemHistory$_get_escalationLevel_$ref_3dgip2() {
  return (p0) => p0.l8w();
}
function LineItemHistory$atTime$lambda(a, b) {
  return a.w26(b) <= 0;
}
function LineItemHistory$before$lambda(a, b) {
  return a.w26(b) < 0;
}
var LineItemHistoryClass;
function LineItemHistory() {
  if (LineItemHistoryClass === VOID) {
    class $ {
      static c8w(item, messages, preSubstantialCompletionAt) {
        preSubstantialCompletionAt = preSubstantialCompletionAt === VOID ? null : preSubstantialCompletionAt;
        var $this = createThis(this);
        $this.u8v_1 = item;
        $this.v8v_1 = messages;
        $this.w8v_1 = preSubstantialCompletionAt;
        var tmp = $this;
        tmp.x8v_1 = lazy(() => {
          var tmp0 = $this.v8v_1;
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp;
              var tmp_0 = element.d8w();
              var tmp0_safe_receiver = tmp_0 instanceof ClientResponse() ? tmp_0 : null;
              if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n8w_1) === true) {
                tmp = element.e6h_1;
              } else {
                tmp = null;
              }
              var result = tmp;
              if (!(result == null)) {
                tmp$ret$1 = result;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          return tmp$ret$1;
        });
        var tmp_0 = $this;
        tmp_0.y8v_1 = lazy(() => {
          var tmp0 = $this.v8v_1;
          var tmp$ret$3;
          $l$block_0: {
            // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp;
              var tmp_0 = element.d8w();
              var tmp0_safe_receiver = tmp_0 instanceof ClientResponse() ? tmp_0 : null;
              if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o8w_1) == null)) {
                tmp = element.e6h_1;
              } else {
                tmp = null;
              }
              var result = tmp;
              if (!(result == null)) {
                tmp$ret$3 = result;
                break $l$block_0;
              }
            }
            tmp$ret$3 = null;
          }
          return tmp$ret$3;
        });
        var tmp_1 = $this;
        tmp_1.z8v_1 = lazy(() => {
          var tmp0 = $this.v8v_1;
          var tmp$ret$5;
          $l$block_1: {
            // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp;
              var tmp_0 = element.d8w();
              var tmp0_safe_receiver = tmp_0 instanceof Accept() ? tmp_0 : null;
              if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p8w_1, RequestResolveLater_instance)) {
                tmp = element.e6h_1;
              } else {
                tmp = null;
              }
              var result = tmp;
              if (!(result == null)) {
                tmp$ret$5 = result;
                break $l$block_1;
              }
            }
            tmp$ret$5 = null;
          }
          return tmp$ret$5;
        });
        var tmp_2 = $this;
        tmp_2.a8w_1 = lazy(() => {
          var tmp0 = $this.v8v_1;
          var tmp$ret$6;
          $l$block_2: {
            // Inline function 'kotlin.collections.count' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$6 = 0;
              break $l$block_2;
            }
            var count = 0;
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (get_isSignOff(element.d8w())) {
                count = count + 1 | 0;
                checkCountOverflow(count);
              }
            }
            tmp$ret$6 = count;
          }
          return tmp$ret$6;
        });
        var tmp_3 = $this;
        tmp_3.b8w_1 = lazy(() => !($this.u8v_1.w6k_1 == null) || !($this.u8v_1.y6k_1 == null) ? null : $this.t8w() ? EscalationLevel_Disputed_getInstance() : $this.s8w() ? EscalationLevel_Issue_getInstance() : $this.r8w() ? EscalationLevel_NotApproved_getInstance() : null);
        return $this;
      }
      static u8w(item, messages, preSubstantialCompletionAt) {
        // Inline function 'kotlin.collections.sortedBy' call
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp = LineItemHistory$_init_$lambda_hk1xcy;
        var tmp$ret$0 = new (sam$kotlin_Comparator$0())(tmp);
        var tmp$ret$1 = sortedWith(messages, tmp$ret$0);
        return this.c8w(item, tmp$ret$1, preSubstantialCompletionAt);
      }
      v8w() {
        return lastOrNull(this.v8v_1);
      }
      r8w() {
        var tmp0 = this.v8v_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp_0 = element.d8w();
            if (tmp_0 instanceof ClientResponse()) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
      h8w() {
        var tmp0 = this.x8v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('issueRaisedAt', 1, tmp, LineItemHistory$_get_issueRaisedAt_$ref_pwsylh(), null);
        return tmp0.f2();
      }
      s8w() {
        return !(this.h8w() == null);
      }
      i8w() {
        var tmp0 = this.y8v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('disputeFiledAt', 1, tmp, LineItemHistory$_get_disputeFiledAt_$ref_2ar8qu(), null);
        return tmp0.f2();
      }
      t8w() {
        return !(this.i8w() == null);
      }
      j8w() {
        var tmp0 = this.z8v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('resolveLaterAcceptedAt', 1, tmp, LineItemHistory$_get_resolveLaterAcceptedAt_$ref_61csev(), null);
        return tmp0.f2();
      }
      w8w() {
        return !(this.w8v_1 == null);
      }
      x8w() {
        return !(this.j8w() == null) && !this.w8w();
      }
      k8w() {
        var tmp0 = this.a8w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('signOffCount', 1, tmp, LineItemHistory$_get_signOffCount_$ref_2pqnxo(), null);
        return tmp0.f2();
      }
      l8w() {
        var tmp0 = this.b8w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('escalationLevel', 1, tmp, LineItemHistory$_get_escalationLevel_$ref_3dgip2(), null);
        return tmp0.f2();
      }
      f8w() {
        var tmp;
        if (this.x8w()) {
          tmp = LineItemState_ResolveLater_getInstance();
        } else {
          var tmp0_safe_receiver = this.l8w();
          tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d8x();
        }
        return tmp;
      }
      e8x() {
        var tmp0_elvis_lhs = this.f8w();
        return tmp0_elvis_lhs == null ? LineItemState_NotApproved_getInstance() : tmp0_elvis_lhs;
      }
      f8x() {
        return this.u8v_1.p6k_1;
      }
      g8x(timestamp) {
        return rewind_0(this, timestamp, LineItemHistory$atTime$lambda);
      }
      h8x(timestamp) {
        return rewind_0(this, timestamp, LineItemHistory$before$lambda);
      }
      toString() {
        return 'LineItemHistory(item=' + this.u8v_1.toString() + ', messages=' + toString(this.v8v_1) + ', preSubstantialCompletionAt=' + toString_0(this.w8v_1) + ')';
      }
      hashCode() {
        var result = this.u8v_1.hashCode();
        result = imul(result, 31) + hashCode(this.v8v_1) | 0;
        result = imul(result, 31) + (this.w8v_1 == null ? 0 : this.w8v_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LineItemHistory()))
          return false;
        if (!this.u8v_1.equals(other.u8v_1))
          return false;
        if (!equals(this.v8v_1, other.v8v_1))
          return false;
        if (!equals(this.w8v_1, other.w8v_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LineItemHistory');
    LineItemHistoryClass = $;
  }
  return LineItemHistoryClass;
}
function _get_previousWasFromClient__woda4q($this) {
  var tmp0_safe_receiver = $this.v8w();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a6h_1;
  return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
}
function _get_awaitingClientAndClientHasRespondedOnce__zj7rf($this) {
  var tmp;
  if ($this.t8x()) {
    var tmp0 = $this.s8x();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection())) {
        tmp_0 = tmp0.i1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.a6h_1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp = tmp$ret$0;
  } else {
    tmp = false;
  }
  return tmp;
}
var ProposalClass;
function Proposal() {
  if (ProposalClass === VOID) {
    class $ {
      constructor(proposal, message) {
        this.u8x_1 = proposal;
        this.v8x_1 = message;
      }
      toString() {
        return 'Proposal(proposal=' + toString(this.u8x_1) + ', message=' + this.v8x_1.toString() + ')';
      }
      hashCode() {
        var result = hashCode(this.u8x_1);
        result = imul(result, 31) + this.v8x_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Proposal()))
          return false;
        if (!equals(this.u8x_1, other.u8x_1))
          return false;
        if (!this.v8x_1.equals(other.v8x_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Proposal');
    ProposalClass = $;
  }
  return ProposalClass;
}
function _get_acceptedProposals__pebjqv($this) {
  var tmp0 = $this.o8x_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('acceptedProposals', 1, tmp, CompletionFlowPermissions$_get_acceptedProposals_$ref_ry0t5w(), null);
  return tmp0.f2();
}
function _get_unacceptedProposals__d4ykds($this) {
  var tmp0 = $this.p8x_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('unacceptedProposals', 1, tmp, CompletionFlowPermissions$_get_unacceptedProposals_$ref_dgo9hn(), null);
  return tmp0.f2();
}
function _get_mostRecentCompletingProposalData__bml1yd($this) {
  var tmp0 = $this.q8x_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('mostRecentCompletingProposalData', 1, tmp, CompletionFlowPermissions$_get_mostRecentCompletingProposalData_$ref_31x6qc(), null);
  return tmp0.f2();
}
function _get_lastAcceptedCompletingProposalData__ngcnj0($this) {
  var tmp0 = $this.r8x_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('lastAcceptedCompletingProposalData', 1, tmp, CompletionFlowPermissions$_get_lastAcceptedCompletingProposalData_$ref_dhoiad(), null);
  return tmp0.f2();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
function CompletionFlowPermissions$_get_acceptedProposals_$ref_ry0t5w() {
  return (p0) => _get_acceptedProposals__pebjqv(p0);
}
function CompletionFlowPermissions$_get_unacceptedProposals_$ref_dgo9hn() {
  return (p0) => _get_unacceptedProposals__d4ykds(p0);
}
function CompletionFlowPermissions$_get_mostRecentCompletingProposalData_$ref_31x6qc() {
  return (p0) => _get_mostRecentCompletingProposalData__bml1yd(p0);
}
function CompletionFlowPermissions$_get_lastAcceptedCompletingProposalData_$ref_dhoiad() {
  return (p0) => _get_lastAcceptedCompletingProposalData__ngcnj0(p0);
}
var CompletionFlowPermissionsClass;
function CompletionFlowPermissions() {
  if (CompletionFlowPermissionsClass === VOID) {
    class $ {
      constructor(lineItem, isClient, role, lineItemMessages, preSubstantialCompletionAt) {
        preSubstantialCompletionAt = preSubstantialCompletionAt === VOID ? null : preSubstantialCompletionAt;
        this.i8x_1 = lineItem;
        this.j8x_1 = isClient;
        this.k8x_1 = role;
        this.l8x_1 = preSubstantialCompletionAt;
        this.m8x_1 = LineItemHistory().u8w(this.i8x_1, lineItemMessages, this.l8x_1);
        var tmp = this;
        var tmp0 = asReversed(this.s8x());
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp_0 = element.d8w();
            var tmp0_safe_receiver = tmp_0 instanceof ClientResponse() ? tmp_0 : null;
            var tmp_1;
            if (tmp0_safe_receiver == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.takeIf' call
              var tmp_2;
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!tmp0_safe_receiver.m8w_1.i1()) {
                tmp_2 = tmp0_safe_receiver;
              } else {
                tmp_2 = null;
              }
              tmp_1 = tmp_2;
            }
            var result = tmp_1;
            if (!(result == null)) {
              tmp$ret$4 = result;
              break $l$block;
            }
          }
          tmp$ret$4 = null;
        }
        var tmp0_safe_receiver_0 = tmp$ret$4;
        tmp.n8x_1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.m8w_1;
        var tmp_3 = this;
        tmp_3.o8x_1 = lazy(() => {
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0 = this.s8x();
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp = element.d8w();
            var tmp0_safe_receiver = tmp instanceof Accept() ? tmp : null;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p8w_1;
            var tmp_0;
            if (tmp1_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_0 = new (Proposal())(tmp1_safe_receiver, element);
            }
            var tmp0_safe_receiver_0 = tmp_0;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.v(tmp0_safe_receiver_0);
            }
          }
          return destination;
        });
        var tmp_4 = this;
        tmp_4.p8x_1 = lazy(() => {
          var tmp0 = _get_acceptedProposals__pebjqv(this);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$14 = item.u8x_1;
            destination.v(tmp$ret$14);
          }
          var accepted = destination;
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0_0 = this.s8x();
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination_0 = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = tmp0_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element = _iterator__ex2g4s_0.o1();
            var tmp = element.d8w();
            var tmp0_safe_receiver = isInterface(tmp, NeedsApproval()) ? tmp : null;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              var tmp_1;
              if (accepted.t1(tmp0_safe_receiver)) {
                accepted.w3(tmp0_safe_receiver);
                tmp_1 = null;
              } else {
                tmp_1 = new (Proposal())(tmp0_safe_receiver, element);
              }
              tmp_0 = tmp_1;
            }
            var tmp0_safe_receiver_0 = tmp_0;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination_0.v(tmp0_safe_receiver_0);
            }
          }
          return destination_0;
        });
        var tmp_5 = this;
        tmp_5.q8x_1 = lazy(() => {
          var tmp0 = _get_unacceptedProposals__d4ykds(this);
          var tmp$ret$26;
          $l$block_0: {
            // Inline function 'kotlin.collections.lastOrNull' call
            var iterator = tmp0.u1(tmp0.p1());
            while (iterator.v6()) {
              var element = iterator.x6();
              if (isComplete((new (Accept())(element.u8x_1, Companion_getInstance().f54_1)).e8w(this.m8x_1.h8x(element.v8x_1.e6h_1)))) {
                tmp$ret$26 = element;
                break $l$block_0;
              }
            }
            tmp$ret$26 = null;
          }
          return tmp$ret$26;
        });
        var tmp_6 = this;
        tmp_6.r8x_1 = lazy(() => {
          var tmp0 = _get_acceptedProposals__pebjqv(this);
          var tmp$ret$28;
          $l$block_1: {
            // Inline function 'kotlin.collections.lastOrNull' call
            var iterator = tmp0.u1(tmp0.p1());
            while (iterator.v6()) {
              var element = iterator.x6();
              if (isComplete((new (Accept())(element.u8x_1, Companion_getInstance().f54_1)).e8w(this.m8x_1.h8x(element.v8x_1.e6h_1)))) {
                tmp$ret$28 = element;
                break $l$block_1;
              }
            }
            tmp$ret$28 = null;
          }
          return tmp$ret$28;
        });
      }
      s8x() {
        return this.m8x_1.v8v_1;
      }
      v8w() {
        return lastOrNull(this.s8x());
      }
      w8w() {
        return this.m8x_1.w8w();
      }
      r8w() {
        return this.m8x_1.r8w();
      }
      h8w() {
        return this.m8x_1.h8w();
      }
      s8w() {
        return !(this.h8w() == null);
      }
      i8w() {
        return this.m8x_1.i8w();
      }
      t8w() {
        return !(this.i8w() == null);
      }
      j8w() {
        return this.m8x_1.j8w();
      }
      x8w() {
        return !(this.j8w() == null) && !this.w8w();
      }
      k8w() {
        return this.m8x_1.k8w();
      }
      l8w() {
        return this.m8x_1.l8w();
      }
      e8x() {
        return this.m8x_1.e8x();
      }
      w8x() {
        var tmp;
        if (this.s8x().i1()) {
          tmp = true;
        } else {
          var tmp0_safe_receiver = this.v8w();
          tmp = equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d8w(), KeepWorking_instance);
        }
        return tmp;
      }
      x8x() {
        var tmp;
        if (!this.j8x_1) {
          var tmp0_safe_receiver = this.v8w();
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d8w();
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_1;
            if (tmp1_safe_receiver instanceof Accept()) {
              var tmp_2 = tmp1_safe_receiver.p8w_1;
              tmp_1 = tmp_2 instanceof Remedy();
            } else {
              tmp_1 = false;
            }
            tmp_0 = tmp_1;
          }
          tmp = tmp_0 === true;
        } else {
          tmp = false;
        }
        return tmp;
      }
      y8x() {
        var tmp;
        if (!this.j8x_1 && !(this.k8x_1 == null) && this.k8x_1.d4(MemberRole_Manager_getInstance()) >= 0) {
          var tmp0_safe_receiver = this.v8w();
          var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d8w();
          tmp = tmp_0 instanceof ClientResolution();
        } else {
          tmp = false;
        }
        return tmp;
      }
      t8x() {
        return this.i8x_1.p6k_1.d4(LineItemState_Resolved_getInstance()) < 0 && this.i8x_1.p6k_1.d4(LineItemState_KeepWorking_getInstance()) > 0 && !_get_previousWasFromClient__woda4q(this);
      }
      z8x() {
        return (this.i8x_1.p6k_1.d4(LineItemState_OnHold_getInstance()) < 0 || (this.x8w() && this.y8x())) && (_get_previousWasFromClient__woda4q(this) || this.w8x() || this.x8x());
      }
      a8y() {
        return this.j8x_1 && this.t8x() || (!this.j8x_1 && this.z8x() && !(this.k8x_1 == null) && this.k8x_1.d4(MemberRole_Manager_getInstance()) >= 0);
      }
      b8y() {
        var tmp;
        if (!this.j8x_1 && !(this.k8x_1 == null) && this.k8x_1.d4(MemberRole_Manager_getInstance()) >= 0 && !this.e8x().equals(LineItemState_Disputed_getInstance())) {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = this.s8x();
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!element.a6h_1) {
              destination.v(element);
            }
          }
          var tmp0_0 = takeLast(destination, 2);
          var tmp$ret$3;
          $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var tmp_0;
            if (isInterface(tmp0_0, Collection())) {
              tmp_0 = tmp0_0.i1();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$3 = true;
              break $l$block_0;
            }
            var _iterator__ex2g4s_0 = tmp0_0.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              if (!equals(element_0.d8w(), MoreInfo_instance)) {
                tmp$ret$3 = false;
                break $l$block_0;
              }
            }
            tmp$ret$3 = true;
          }
          tmp = !tmp$ret$3;
        } else {
          tmp = false;
        }
        return tmp;
      }
      c8y() {
        var tmp;
        if (this.j8x_1) {
          var tmp0_safe_receiver = this.v8w();
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d8w();
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_1;
            var tmp_2;
            if (tmp1_safe_receiver instanceof ForceComplete()) {
              tmp_2 = true;
            } else {
              tmp_2 = equals(tmp1_safe_receiver, RequestResolveLater_instance);
            }
            if (tmp_2) {
              tmp_1 = true;
            } else {
              tmp_1 = tmp1_safe_receiver instanceof RequestSiteVisit();
            }
            tmp_0 = tmp_1;
          }
          tmp = tmp_0 === true;
        } else {
          tmp = false;
        }
        return tmp;
      }
      d8y() {
        return this.j8x_1 && this.i8x_1.u6k_1 == null && (this.i8x_1.r6k_1 || _get_awaitingClientAndClientHasRespondedOnce__zj7rf(this)) && !this.x8w();
      }
      e8y() {
        return this.j8x_1 && this.i8x_1.u6k_1 == null && this.c8y();
      }
      f8y() {
        return this.j8x_1 && !(this.i8x_1.u6k_1 == null) && !this.t8w() && this.c8y();
      }
      g8y() {
        return this.j8x_1 && !this.t8w() && (this.i8x_1.s6k_1 || (this.t8x() && this.s8w())) && !this.x8w();
      }
      h8y() {
        var tmp;
        if (this.i8x_1.t6k_1) {
          var tmp0_safe_receiver = this.k8x_1;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = tmp0_safe_receiver.d4(MemberRole_Manager_getInstance()) >= 0;
          }
          var tmp1_elvis_lhs = tmp_0;
          tmp = tmp1_elvis_lhs == null ? this.j8x_1 : tmp1_elvis_lhs;
        } else {
          tmp = false;
        }
        return tmp;
      }
      i8y() {
        return false;
      }
      j8y() {
        var tmp;
        var tmp_0;
        if (!isComplete(this.i8x_1.p6k_1)) {
          var tmp0_safe_receiver = this.v8w();
          var tmp_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d8w();
          tmp_0 = !(tmp_1 instanceof Appeal());
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var tmp_2;
          if (this.t8w()) {
            var tmp_3;
            if (this.a8y() || this.h8y()) {
              tmp_3 = true;
            } else {
              var tmp1_safe_receiver = this.v8w();
              var tmp_4;
              if (tmp1_safe_receiver == null) {
                tmp_4 = null;
              } else {
                // Inline function 'kotlin.let' call
                // Inline function 'com.lightningkite.now' call
                var tmp_5 = get_default(Companion_instance).b1m().v26(tmp1_safe_receiver.e6h_1);
                // Inline function 'kotlin.time.Companion.hours' call
                Companion_getInstance_0();
                var tmp$ret$1 = toDuration(24, DurationUnit_HOURS_getInstance());
                tmp_4 = Duration__compareTo_impl_pchp0f(tmp_5, tmp$ret$1) > 0;
              }
              tmp_3 = tmp_4 === true;
            }
            tmp_2 = tmp_3;
          } else {
            tmp_2 = false;
          }
          tmp = !!(tmp_2 | (this.x8w() && setOf([LineItemState_ResolveLater_getInstance(), LineItemState_RequestingReview_getInstance()]).t1(this.i8x_1.p6k_1)));
        } else {
          tmp = false;
        }
        return tmp;
      }
      k8y() {
        return this.x8w() && this.i8x_1.p6k_1.equals(LineItemState_ResolveLater_getInstance()) || this.h8y();
      }
      l8y() {
        return this.j8x_1 && this.j8y() || (!this.j8x_1 && !(this.k8x_1 == null) && this.k8x_1.d4(MemberRole_Manager_getInstance()) >= 0 && this.k8y());
      }
      m8y() {
        var tmp0_safe_receiver = lastOrNull(_get_unacceptedProposals__d4ykds(this));
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v8x_1;
      }
      n8y() {
        var tmp0_safe_receiver = lastOrNull(_get_unacceptedProposals__d4ykds(this));
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u8x_1;
      }
      o8y() {
        var tmp0_safe_receiver = _get_mostRecentCompletingProposalData__bml1yd(this);
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u8x_1;
      }
      p8y() {
        var tmp0_safe_receiver = _get_mostRecentCompletingProposalData__bml1yd(this);
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v8x_1;
      }
      q8y() {
        var tmp0_safe_receiver = _get_lastAcceptedCompletingProposalData__ngcnj0(this);
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u8x_1;
      }
      r8y() {
        var tmp0 = this.s8x();
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.lastOrNull' call
          var iterator = tmp0.u1(tmp0.p1());
          while (iterator.v6()) {
            var element = iterator.x6();
            if (!element.a6h_1) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        return tmp$ret$1;
      }
      s8y() {
        var tmp;
        if (this.s8w()) {
          tmp = true;
        } else {
          var tmp0_safe_receiver = this.r8y();
          var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d8w();
          tmp = tmp_0 instanceof MoreInfo();
        }
        return tmp;
      }
      t8y() {
        return this.j8x_1 && !(this.n8y() == null) && this.i8x_1.p6k_1.d4(LineItemState_InProgress_getInstance()) > 0 && this.i8x_1.p6k_1.d4(LineItemState_Resolved_getInstance()) < 0;
      }
      u8y() {
        return this.a8y() || this.d8y() || this.e8y() || this.g8y() || this.f8y() || this.l8y() || this.h8y();
      }
      v8y() {
        return !(this.i8x_1.w6k_1 == null);
      }
    }
    initMetadataForClass($, 'CompletionFlowPermissions');
    CompletionFlowPermissionsClass = $;
  }
  return CompletionFlowPermissionsClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  CompletionFlowPermissions as CompletionFlowPermissionsj7m9votfuuvc,
  LineItemHistory as LineItemHistory34tsqqs4wiqdw,
};
//endregion

//# sourceMappingURL=CompletionFlowPermissions.mjs.map
